<style scoped>
    .expand-row{
        margin-bottom: 16px;
    }
</style>
<template>
    <div>
         <Table :columns="columnsExpand" :data="row.serialNos" ref="table" :show-header="false"></Table>
    </div>
</template>
<script>
    import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
    import Util from '@/lib/util'
    import AppConsts from '../../lib/appconst';
  
    export default {
        props: {
            row: Object
        },
         data() {
            var columns =  [
                    {
                        title: Util.L('Serial'),
                        key: 'serialNo'
                    }
                ]
            return {
                columnsExpand : columns
            }
        },
    };
</script>
